import React, {useEffect, useState} from "react";
import Header from "../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../services/StorageService.js";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, procStatuses} from "../util/Constants.js";
import {calculatePercentage, getAppLocale, getLastDay, getTotalProducts, renderProducts} from "../util/common";
import {PATH} from "../routes/routes.js";
import analyticsLogEvent from "../services/FirebaseService";
import iconPhone from "../assets/img/icon_phone_black.svg"
import * as ProductService from "../services/ProductService";

import {DATE_FORMAT} from "../util/DateUtil";
import Moment from "react-moment";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function OrderHistory() {
    const navigateTo = useNavigate();
    const {orderId} = useParams();
    const currency = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).currency:null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const places = {
        DELIVERY: "DELIVERY",
        TAKEAWAY: "TAKE_AWAY",

    }
    const [state, setState] = useState({
        loading: false,
        allOrderProducts: StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)?JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)):null,
        discount:null,
        procStatus:null,
        lastMod:null,
        paymentMethod:null,
        tips:null,
        place:null,
        table:null,
        deliveryFee:null
    });

    useEffect(() => {
        let delayDebounceFn = null;
        delayDebounceFn = setTimeout(() => {
            checkIfOrderWasChanged();
        }, 10000)
        return () => clearTimeout(delayDebounceFn);
    }, [state]);


    useEffect(() => {

        if (state.allOrderProducts==null) {
            navigateTo(PATH.ALL_PRODUCTS);
        }
        checkIfOrderWasChanged();
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.THANK_YOU,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.THANK_YOU
        });
    }, []);


     async function checkIfOrderWasChanged()  {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "fromDate": getLastDay(),
            // "procStatus": ["OPEN", "CONFIRMED", "READY", "DELIVERED"]
        }

        const response = await ProductService.getAllProductsOrders(body);
        if (response.ok) {
            let currentOrder = null;
            const storageCurrentOrderId = orderId;
            for(let i=0; i < response.data.orders.length;i++){
                const o = response.data.orders[i];
                if(o.oid === storageCurrentOrderId){
                    currentOrder = o;
                    break;
                }
                if(currentOrder === null && o.procStatus === "OPEN"){
                    currentOrder = o;
                }
            }

            setState({
                ...state,
                procStatus:currentOrder?.procStatus,
                lastMod:currentOrder?.lastMod,
                discount: currentOrder?.discount,
                paymentMethod: currentOrder?.paymentMethod,
                deliveryFee:currentOrder?.deliveryFee,
                tips:currentOrder?.tips,
                place:currentOrder.place,
                table:currentOrder.table,
            })

            if (currentOrder.lastMod !== state.allOrderProducts.lastMod && currentOrder.procStatus !=="DELIVERED" &&
                ( JSON.stringify(currentOrder.products)!== JSON.stringify(state.allOrderProducts.products)))  {
                setState({
                    ...state,
                    allOrderProducts: currentOrder
                })
                StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS, JSON.stringify(currentOrder));
                return true
            }else{
                return false;
            }
        }
    }

    const calculateTotalPrice = () => {
        if (state.discount) {
            return  state.allOrderProducts.price / 100.0 - state.discount / 100.0;
        }else{
           return state.allOrderProducts.price / 100.0;
        }
    }




    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={<FormattedMessage id="OrderDetails"/>}
                hasBackBtn={true}
            />

            <main className="page-content thank-you-page-content">
                <div className="container-title">
                    {JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).title}
                </div>
                {shopDetails.data?.phone && <div className="container-phone">
                    <a href={"tel:" + shopDetails.data.phone}>

                    <img src={iconPhone}/>
                        <h3 className="phone">{shopDetails.data.phone}</h3>
                    </a>
                </div>}

                <div className="container-table-and-order-id">
                    <h3 className="faded-text">
                        {state.place === places.DELIVERY ? <FormattedMessage id="Delivery"/>  : state.place === places.TAKEAWAY ? <FormattedMessage id="Takeaway"/>  : null}
                        {state.table? state.table + "," : null}
                        &nbsp;<FormattedMessage id="OrderNumber"/> {orderId}
                    </h3>
                </div>
                {state.procStatus === procStatuses.DELIVERED && <div className="container-date-and-time">
                    <h3 className="faded-text">
                        <Moment
                            format={DATE_FORMAT.DAY_MONTH_YEAR_HOUR_MINUTES}
                            date={state.lastMod}
                        />
                    </h3>
                </div>}

                <div className="order-details-card no-bg">
                    <div className="card-content">
                        {
                            renderProducts(state.allOrderProducts)
                        }

                        {state.discount &&
                        <div className="subtotal-and-discount-container">
                          <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.allOrderProducts.price / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                          </div>
                            <div className="row discount-row">
                                 <span className="subtotal-label">
                                      <FormattedMessage
                                          id="Discount"
                                      />
                                </span>
                                <span className="discount-percentage">
                                    &nbsp;{calculatePercentage(state.discount  / 100.0, state.allOrderProducts.price / 100.0, 2)}%
                                </span>
                                <span className="total-price">-
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.discount / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>

                        </div>
                        }
                        {(state.tips && state.tips !== 0) &&
                        <div className="subtotal-and-discount-container">
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.allOrderProducts.price / 100.0 - state.tips / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                    <FormattedMessage id="Tip"/>
                                </span>
                                <span className="total-price"> + &nbsp;
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.tips / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                        </div>
                        }

                        {(state.place === places.DELIVERY && state.deliveryFee) && <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="DeliveryFee"
                                  />
                                </span>
                            <span className="total-price">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.deliveryFee / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                        </div>}



                        <div className="total-container row">

                            <span className="total-prod-nr">{
                                getTotalProducts(state.allOrderProducts.products)
                            }&nbsp;</span>
                            <span className="total-prod-label">{getTotalProducts(state.allOrderProducts.products) !==1 ?  <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                            <span className="total-price" data-qa="thank-you-total-price">
                                {<FormattedMessage id="Total"/>}&nbsp;
                                 <IntlProvider locale={getAppLocale()}>
                                 <FormattedNumber
                                     value={calculateTotalPrice()}
                                     style="currency"
                                     minimumFractionDigits={2}
                                     maximumFractionDigits={2}
                                     currency={currency} />
                                 </IntlProvider>
                            </span>
                        </div>



                    </div>
                </div>

            </main>


        </>


    );
}

export default OrderHistory;
